import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components';
import styles from './EmptyStatePopup.scss';

const EmptyStatePopup = ({ emptyStateMessage }) =>
  <div
    className={styles.emptyStateContainer}
    data-testid='alerts-popOver__empty-notifications'
  >
    <div className={styles.contentContainer}>
      <div className={styles.bellContainer}>
        <Icon aria-hidden="true" name='ion-md-notifications' className={styles.bellIcon} />
      </div>
      <div className={styles.emptyStateMessage}>
        {emptyStateMessage}
      </div>
    </div>
  </div>

EmptyStatePopup.propTypes = {
  emptyStateMessage: PropTypes.string.isRequired,
};

export default EmptyStatePopup;
